import { JsonHierarchyElement } from "@psnb/nwt-api";

export class HierarchyNode {
  constructor(
    public item: JsonHierarchyElement,
    public level: number = 1,
    public expandable: boolean = false,
    public isLoading: boolean = false,
    public disableButton: boolean = true,
    public disableChecked: boolean = false,
    public disableCheckBox: boolean = false)
    { }
}